import React from "react";
import Contacto from "./Contacto.js";
import Evento from "./Evento.js";
import Header from "./Header.js";
import "./Main.css";
// eslint-disable-next-line
import PuestoVenta from "./PuestoVenta.js";
import SliderHome from "./SliderHome.js";
import EntradaSection from "./EntradaSection.js";
import Sectores from "./Sectores.js";
import PlanoSectores from "./PlanoSectores.js";
import Fiesta from "./Fiesta.js";
class HomeView extends React.Component {
  constructor(props) {
    super(props);
    this.state = { visible: "home" };

    const eventDate = new Date("2026-10-31T20:00:00");
    const finevento = new Date("2026-11-01T06:00:00");
    localStorage.setItem("eventDate", eventDate);
    localStorage.setItem("finevento", finevento);

    this.scrollDivHome = React.createRef();
    this.scrollDivevento = React.createRef();
    this.scrollEntradaGeneral = React.createRef();
    this.scrollEntradaTribuna = React.createRef();
    this.scrollEntradaPlateaVR = React.createRef();
    this.scrollDivSectores = React.createRef();
    this.scrollDivPlanoSectores = React.createRef();
    this.scrollDivPuntoVenta = React.createRef();
	this.scrollDivContacto = React.createRef();
	this.scrollDivFiesta = React.createRef();
  }

  redirect = (name) => {
    const refMap = {
      home: this.scrollDivHome,
      evento: this.scrollDivevento,
      "entrada-general": this.scrollEntradaGeneral,
      "entrada-tribuna": this.scrollEntradaTribuna,
      "entrada-platea-vr": this.scrollEntradaPlateaVR,
      sectores: this.scrollDivSectores,
      planosectores: this.scrollDivPlanoSectores,
      puntoventa: this.scrollDivPuntoVenta,
      contacto: this.scrollDivContacto,
      fiesta: this.scrollDivFiesta,
    };

    const ref = refMap[name.toLowerCase()];
    if (ref && ref.current) {
      const elementPosition = ref.current.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: elementPosition, behavior: "smooth" });
      this.setState({ visible: name.toLowerCase() });
    }
  };

  render() {
    return (
      <div>
        <Header state={this.state.visible} redirect={this.redirect} />

        <div style={{ maxWidth: "100vw" }}>
          <div id="Home" ref={this.scrollDivHome}>
            <SliderHome />
          </div>
          <div id="Fiesta" ref={this.scrollDivFiesta}>
            <Fiesta />
          </div>
          <div id="Evento" ref={this.scrollDivevento}>
            <Evento />
          </div>
          <div id="PlanoSectores" ref={this.scrollDivPlanoSectores}>
            <PlanoSectores />
          </div>
          <div id="Sectores" ref={this.scrollDivSectores}>
            <Sectores />
          </div>

          <div id="EntradaGeneral" ref={this.scrollEntradaGeneral}>
            <EntradaSection tierKey="pulso" />
          </div>
          <div id="EntradaTribuna" ref={this.scrollEntradaTribuna}>
            <EntradaSection tierKey="orbita" />
          </div>
          <div id="EntradaPlateaVR" ref={this.scrollEntradaPlateaVR}>
            <EntradaSection tierKey="orbita-vr" />
          </div>

          <div id="Contacto" ref={this.scrollDivContacto}>
            <Contacto />
          </div>
        </div>
      </div>
    );
  }
}

export default HomeView;
